import { render } from "./ViewUserCompetition.vue?vue&type=template&id=67e1f729&scoped=true"
import script from "./ViewUserCompetition.vue?vue&type=script&lang=js"
export * from "./ViewUserCompetition.vue?vue&type=script&lang=js"

import "./ViewUserCompetition.vue?vue&type=style&index=0&id=67e1f729&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67e1f729"]])

export default __exports__